import {BarOrientation, BarSortOrder, ChartSettings, DataLabelPosition} from 'entities/chart';
import {ChartType} from '@/views/storyboard/utils/chartConstants';

export const CHART_SETTINGS_FIELD_DEFAULTS: Pick<
    ChartSettings,
    | 'linearRegression'
    | 'comparablePeriod'
    | 'ignoreGlobalFilters'
    | 'movingAverageDays'
    | 'movingAverageDaysCenter'
    | 'scalingFactor'
    | 'barOrientation'
    | 'barSortOrder'
    | 'dataLabelPosition'
> = {
    linearRegression: false,
    comparablePeriod: true,
    ignoreGlobalFilters: false,
    movingAverageDays: null,
    movingAverageDaysCenter: true,
    scalingFactor: '',
    barOrientation: BarOrientation.Vertical,
    barSortOrder: BarSortOrder.HighToLow,
    dataLabelPosition: DataLabelPosition.Off,
};

export const getChartSettingsFieldDefaults = (comment = false): ChartSettings => ({
    title: '',
    description: '',
    type: comment ? ChartType.Comment : ChartType.BarChart,
    width: 2,
    height: 2,
    ...CHART_SETTINGS_FIELD_DEFAULTS,
});
